import { render, staticRenderFns } from "./stepUi.vue?vue&type=template&id=fd354dd6&scoped=true&"
import script from "./stepUi.vue?vue&type=script&lang=js&"
export * from "./stepUi.vue?vue&type=script&lang=js&"
import style0 from "./stepUi.vue?vue&type=style&index=0&id=fd354dd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd354dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd354dd6')) {
      api.createRecord('fd354dd6', component.options)
    } else {
      api.reload('fd354dd6', component.options)
    }
    module.hot.accept("./stepUi.vue?vue&type=template&id=fd354dd6&scoped=true&", function () {
      api.rerender('fd354dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/templateMgr/components/valueRecordType/stepUi.vue"
export default component.exports